export function isValidURL(string:any) {  
  /// checking for double slashes in url ()
    if (string.match(/([^:]\/)\/+/g)) 
    return false;
    // validating url , accepts localhost too
    var res = string.match(/^(http|https|:\/\/|\.|@){2,}(localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}|\S*:\w*@)*([a-zA-Z]|(\d{1,3}|\.){7}){1,}(\w|\.{2,}|\.[a-zA-Z]{2,3}|\/|\?|&|:\d|@|=|\/|\(.*\)|#|-|%)*$/gum);
    return (res !== null)
  };